export default __webpack_public_path__ + "static/media/data_setting_8.fafb8f38.png";